module.exports = __webpack_public_path__ + "img/IT0000253660713.2f82c212.png";